import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Heading, Text, BaseLayout } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import Page from 'components/layout/Page'
import FarmStakingCard from 'views/Home/components/FarmStakingCard'
// import LotteryCard from 'views/Home/components/LotteryCard'
import CakeStats from 'views/Home/components/CakeStats'
import TotalValueLockedCard from 'views/Home/components/TotalValueLockedCard'
import EarnAPYCard from 'views/Home/components/EarnAPYCard'
import EarnAssetCard from 'views/Home/components/EarnAssetCard'
import WinCard from 'views/Home/components/WinCard'
import { useLocation } from 'react-router'
import { getReferralsAddress } from 'utils/addressHelpers'
import { AbiItem } from 'web3-utils'
import Web3 from 'web3'
import {ethers} from 'ethers'
import referralsABI from '../../config/abi/referrals.json';


const chainId = process.env.REACT_APP_CHAIN_ID;
const ownerAddress = process.env.REACT_APP_WALLET_ADDRESS;
const web3 = new Web3(Web3.givenProvider)



const WALLET_PRIVATE_KEY = process.env.REACT_APP_WALLET_PRIVATE_KEY
const signers = new ethers.Wallet(WALLET_PRIVATE_KEY)


const Hero = styled.div`
  align-items: center;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  margin-bottom: 32px;
  padding-top: 116px;
  text-align: center;

  ${({ theme }) => theme.mediaQueries.lg} {
    background-position: left center, right center;
    height: 165px;
    padding-top: 0;
  }
`

const Cards = styled(BaseLayout)`
  align-items: stretch;
  justify-content: center;
  margin-bottom: 32px;
  display: flex;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
      width:50%
    }
  }
`

const CTACards = styled(BaseLayout)`
  align-items: start;
  margin-bottom: 32px;

  & > div {
    grid-column: span 6;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`

let i = 0;

async function referralsSystem(location){
  console.log(`location ============= ${JSON.stringify(location)}`)
    if(location.pathname.includes("referred")){
      const referrerAddress = location.pathname.substring(location.pathname.lastIndexOf("/")+1,location.pathname.length)
      if(referrerAddress.length > 0){
          console.log(`referrerAddress ===== ${referrerAddress} ${referrerAddress.length}`)
          const checkAddress = await web3.utils.isAddress(referrerAddress);
          if(checkAddress) {
          const accounts = await web3.eth.getAccounts();
          const account = accounts[0];
          console.log(`account======${account}`)
          console.log(` getReferralsAddress()======${ getReferralsAddress()}`)
          const referralsAddress = getReferralsAddress();

          const referralsContract = new web3.eth.Contract((referralsABI as unknown) as AbiItem, referralsAddress)
          const friend = await referralsContract.methods.getNightmareFriend(account).call();
          console.log(`friend =========== ${friend}`);
              if(friend==="0x0000000000000000000000000000000000000000" && i===0 && friend!== account)
                 {
                  i++;
                  const myData =  await referralsContract.methods.setNightmareFriend(account,referrerAddress).encodeABI();
                  const txCount = await web3.eth.getTransactionCount(ownerAddress);
                  const gas = await web3.eth.getGasPrice();
                  const gasLimit1 = await web3.eth.estimateGas({
                    from: ownerAddress,
                    nonce: txCount,
                    to: referralsAddress,
                    data: myData,
                  })

                  console.log(`myData ===== ${myData}`)
                  console.log(`txCount ===== ${txCount}`)
                  console.log(`gas ===== ${gas}`)
                  console.log(`gasLimit1 ===== ${gasLimit1}`)

                  await signers.signTransaction({
                    "nonce":  web3.utils.toHex(txCount), // 0 in decimal
                    "gasLimit": web3.utils.toHex(gasLimit1), // 21000 in decimal
                    "gasPrice": web3.utils.toHex(gas), // 2000000000 in decimal
                    "to": referralsAddress,
                    "value": "0x00", // 100000000000000000 in decimal
                    "data":web3.utils.toHex(myData), // “empty” value in decimal
                    "chainId": 97
                  })
                  .then(async res=> {
                    const promises = [];
                    let tx;
                      promises.push(web3.eth.sendSignedTransaction(res,(err,txResult) => {
                        tx = txResult
                        return tx;
                      }));
                      await Promise.all(promises)
                      console.log(`txhash1 ====== ${tx}`)
                  })
                  .catch(e=>{
                    console.error(`error occured during transaction Error: ${e}`)
                  }) 

                }
          } 
        }

      } 


}



const Home: React.FC = () => {
    // let i = 0;
  // async()=>{
    const TranslateString = useI18n()
    const location = useLocation()
    referralsSystem(location);
    // i++;

    return (
    <Page>
      <Hero >
        <Heading as="h1" className="hero-test" size="xl" mb="24px" color="#E2E1EC">
          {TranslateString(576, 'Nightmare Finance')}
        </Heading>
        <Text color="#A28BD4">{TranslateString(578, 'The #1 AMM and yield farm on Matic network.')}</Text>
      </Hero>
      <div> 
        <Cards>
          <FarmStakingCard />
          {/* <LotteryCard /> */}
        </Cards>
        <CTACards>
          <EarnAPYCard />
          <EarnAssetCard />
          {/* <WinCard /> */}
        </CTACards>
        <Cards>
          <CakeStats />
          <TotalValueLockedCard />
        </Cards>
      </div>
    </Page>
  )
  // }
}

export default Home
